import { useUserName } from 'hooks/useUserName'
import React from 'react'
import { Text } from '@chakra-ui/core'
import strings from 'constants/strings'

interface IProps {
  created_by: string
}

export const PopCreatorText = ({ created_by }: IProps) => {
  const userName = useUserName(created_by)
  const title = userName.trim() ? userName : strings.COMPANY_NAME

  return (
    <Text dir="auto" fontWeight="600">
      {title}
    </Text>
  )
}
